import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';

@Component({
	selector: 'fb-filter-paginator',
	templateUrl: './filter-paginator.component.html',
	styleUrls: ['./filter-paginator.component.scss']
})
export class FilterPaginatorComponent implements OnChanges {


	@Input() public totalItems: number = 0;
	@Input() public itemsPerPage: number = 12;
	@Input() public currentPage: number = 1;
	@Output() public pageChanged: EventEmitter<number> = new EventEmitter<number>();

	public totalPages: number = 1;
	public maxPagesToShow: number = 5;


	ngOnChanges() {
		this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
		if(this.currentPage > this.totalPages) {
			this.firstPage();
		}
	}


	public get pages(): number[] {
		const pagesToShow = Math.min(this.maxPagesToShow, this.totalPages);
		const startPage = Math.max(1, this.currentPage - Math.floor(pagesToShow / 2));
		const endPage = Math.min(this.totalPages, startPage + pagesToShow - 1);

		return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
	}

	public nextPage(): void {
		if (this.currentPage < this.totalPages) {
			this.changePage(this.currentPage + 1);
		}
	}

	public prevPage(): void {
		if (this.currentPage > 1) {
			this.changePage(this.currentPage - 1);
		}
	}

	protected changePage(page: number): void {
		this.currentPage = page;
		this.pageChanged.emit(this.currentPage);
	}


	public firstPage(): void {
		this.changePage(1);
	}

	public lastPage(): void {
		this.changePage(this.totalPages);
	}

}
